export enum DeclarationTypes {
    //grid
    GET_DECLARATION_LOADING = '@@declarations/GET_DECLARATION_LOADING',
    GET_DECLARATION_SUCCESS = '@@declarations/GET_DECLARATION_SUCCESS',
    GET_DECLARATION_FAIL = '@@declarations/GET_DECLARATION_FAIL',

    GET_MANUFACTURER_DROPDOWN_LOADING = '@@declarations/GET_MANUFACTURER_DROPDOWN_LOADING',
    GET_MANUFACTURER_DROPDOWN_SUCCESS = '@@declarations/GET_MANUFACTURER_DROPDOWN_SUCCESS',
    GET_MANUFACTURER_DROPDOWN_FAIL = '@@declarations/GET_MANUFACTURER_DROPDOWN_FAIL',

    GET_DECLARATION_BY_ID_LOADING = '@@declarations/GET_DECLARATION_BY_ID_LOADING',
    GET_DECLARATION_BY_ID_SUCCESS = '@@declarations/GET_DECLARATION_BY_ID_SUCCESS',
    GET_DECLARATION_BY_ID_FAIL = '@@declarations/GET_DECLARATION_BY_ID_FAIL',

    CREATE_DECLARATION_FORM_LOADING = '@@declarations/CREATE_DECLARATION_FORM_LOADING',
    CREATE_DECLARATION_FORM_SUCCESS = '@@declarations/CREATE_DECLARATION_FORM_SUCCESS',
    CREATE_DECLARATION_FORM_FAIL = '@@declarations/CREATE_DECLARATION_FORM_FAIL',

    PRINT_DECLARATION_FORM_LOADING = '@@declarations/PRINT_DECLARATION_FORM_LOADING',
    PRINT_DECLARATION_FORM_SUCCESS = '@@declarations/PRINT_DECLARATION_FORM_SUCCESS',
    PRINT_DECLARATION_FORM_FAIL = '@@declarations/PRINT_DECLARATION_FORM_FAIL',

    MAIL_DECLARATION_FORM_LOADING = '@@declarations/MAIL_DECLARATION_FORM_LOADING',
    MAIL_DECLARATION_FORM_SUCCESS = '@@declarations/MAIL_DECLARATION_FORM_SUCCESS',
    MAIL_DECLARATION_FORM_FAIL = '@@declarations/MAIL_DECLARATION_FORM_FAIL',


    CLEAR_MESSAGE = '@@declarations/CLEAR_MESSAGE',
    RESET_MESSAGE = '@@declarations/RESET_MESSAGE',
}